<template>
<!-- Using vuefire (the official Firebase binding) -->
<div id="pledge-wrap">
  <div class="pure-g">
        <div id="pledge-text" class="pure-u-1 pure-u-lg-13-24">
          
        <table id="runners-info">
          <tr>
            <td>
                <p v-if="this.sharedState.wasReferred">
                  <img v-show="this.sharedState.wasReferred && this.sharedState.referralUser.photo" :src="this.sharedState.referralUser.photo" id="referralImage" /> {{ this.sharedState.referralUser.name | firstName }} and
                </p>
                <p id="total-runners" :class="resizeCounter()">{{formattedTotalPeople}}</p><!-- 2,651 -->
                <p>people will be running in {{this.sharedState.year}}</p>
            </td>
          </tr>
        </table>

          <div class="pledge-footer noSelect">
            <ul id="footer-social">
              <li class="twitter" @click="share('twitter')"><span class="icon-twitter"></span> Tweet</li>
              <li class="facebook" @click="share('facebook')"><span class="icon-facebook-official"></span> Share</li>
              <li class="linkedin" @click="share('linkedin')"><span class="icon-linkedin-squared"></span> Share</li>
            </ul>
          </div>
        </div>
        <div id="pledge-form" class="pure-u-1 pure-u-lg-11-24">
          <!-- Start of sign pledge -->
          <section v-show="!this.isPledgeCompleted">
            <h3><span>Pledge to run</span></h3>

            <form id="form" name="emailForm" v-on:submit.prevent="pledge('password')">
              <div id="manualForm" class="pure-g" v-if="this.pledgeVia === 'password'">
                <div class="pure-u-2-5 inputWrap">
                  <input type="text" name="name" class="inputField name" placeholder="Name" v-model="newUser.name" />
                </div>
                <div class="pure-u-3-5 inputWrap">
                  <input type="text" name="email" class="inputField email" v-model="newUser.email" placeholder="Email address" />
                </div>
              </div>
            </form>

            <div id="pledgeButtons" class="noSelect">
              <div v-if="this.pledgeVia === 'facebook.com'">
                <div class="button facebook">
                  <button v-on:click="pledge('facebook.com')">Pledge to run via Facebook</button>
                  <icon type="icon-facebook" dropdown="true"></icon>
                </div>
              </div>
              <div v-else-if="this.pledgeVia === 'twitter.com'">
                <div class="button twitter">
                  <button v-on:click="pledge('twitter.com')">Pledge to run via Twitter</button>
                  <icon type="icon-twitter" dropdown="true"></icon>
                </div>
              </div>
              <div v-else-if="this.pledgeVia === 'google.com'">
                <div class="button google">
                  <button v-on:click="pledge('google.com')">Pledge to run via Google</button>
                  <icon type="icon-google" dropdown="true"></icon>
                </div>
              </div>
              <div v-else-if="this.pledgeVia === 'password'">
                <div class="button email">
                  <button v-on:click="pledge('password')">Pledge to run</button>
                  <icon type="icon-mail" dropdown="true"></icon>
                </div>
              </div>

              <select name="pledgeOptions" id="pledgeOptions" v-model="pledgeVia">
                <option value="facebook.com">Pledge via Facebook</option>
                <option value="twitter.com">Pledge via Twitter</option>
                <option value="google.com">Pledge via Google</option>
                <option value="password">Pledge via Email address </option>
              </select>
            </div>

            <ul class="errors" v-if="(this.pledgeVia === 'password' && showErrors)">
              <li v-show="!validation.name">Name cannot be empty.</li>
              <li v-show="!validation.email">Please provide a valid email address.</li>
            </ul>
            
            <div id="privacy">
              <label class="icon-lock"></label>
              <p><i>We will <b>not</b> post anything on your behalf</i>, spam or share your details with third parties.</p>
            </div>

          </section>
          <!-- End of sign pledge -->

          <!-- Start of share pledge -->
          <section v-show="this.isPledgeCompleted">
            <h3><span>Encourage others to run</span></h3>
            <p class="bottomMargin">Share your pledge to run in {{this.sharedState.year}} and encourage people like you get fit and stay healthy.</p>
            <div id="shareButtons">
              
              <div>
                <div class="button facebook">
                  <button v-on:click="share('facebook')">
                    <icon type="icon-facebook" dropdown="false"></icon>
                    Share on Facebook
                  </button>
                </div>
              </div>
              <div>
                <div class="button twitter">
                  <button v-on:click="share('twitter')">
                    <icon type="icon-twitter" dropdown="false"></icon>
                    Share on Twitter
                  </button>
                </div>
              </div>
              <div>
                <div class="button linkedin">
                  <button v-on:click="share('linkedin')">
                    <icon type="icon-linkedin" dropdown="false"></icon>
                    Share on LinkedIn
                  </button>
                  
                </div>
              </div>
              <div>
                <div class="shareLink">
                  <input type="text" name="shareLink" class="inputField" readonly="readonly" :value="this.getSharingUrl()" placeholder="URL here" onClick="this.setSelectionRange(0, 9999)" />
                </div>
              </div>

            </div>

          </section>
          <!-- End of share pledge -->

          <!-- Start of about -->
          <section v-show="!this.isPledgeCompleted">
            <h3><span>Why pledge to run?</span></h3>
            <p>Running is a great free way to get fit and healthy. Take this pledge to show your determination, get reminders about your runs and access useful resources to get you started.
            <br/><br/><read-more newLine="true">
              To get you started we have curated a list of {{ this.sharedState.totalResources }} resources (and growing) including races, apps, clothing and tips & tricks to avoid injuries. To access this list, make sure you pledge to run in {{this.sharedState.year}}.
              <br/><br/>
              If you have any suggestion, would like to help us get more people fit or have found a race, accessory, or article you think we should cover, <a href="mailto:run@runningyear.com" target="new">please get in touch</a>.
            </read-more>
            </p>
          </section>
          <!-- End of about -->

          <div class="pledge-footer">
            <ul id="footer-email">
              <li class="email" @click="share('email')"><span class="icon-mail"></span> Share by Email</li>
            </ul>
          </div>

        </div>
  </div>
  <!--
  <ul is="transition-group">
    <li v-for="user in users" class="user" :key="user['.key']">
      <span>{{user.name}} - {{user.email}}</span>
      <button v-on:click="removeUser(user)">X</button>
    </li>
  </ul>
  -->
  

</div>
</template>

<script>

var Vue = require('vue')
//Vue.component('dropdown-arrow', {template: '<span class="dropdown-arrow icon-down-dir"></span>'});

Vue.component('icon', {
  // declare the props
  props: ['type', 'dropdown'],

  methods: {
    showDropdown: function(event){
      return (this.dropdown === "true");
    }
  },
  template: '<label><span :class="type"></span><span v-if="showDropdown()" class="dropdown-arrow icon-down-open"></span></label>'
})

Vue.component('read-more', {
  props: ['newLine'],
  data:  function () {
    return {
      slotVisible : false
    }
  },
  methods: {
    showText: function(event){
      //console.log(event);
      this.slotVisible = true;
      return false;
    },
    isNewLine: function(evenet){
      return this.newLine;
    }
  },
  template: '<span><span v-show="!this.slotVisible"><span v-if="!isNewLine()">... </span><a href="#read-more" class="read-more" v-on:click.prevent="showText"><span v-if="isNewLine()">Read more</span><span v-else>read more</span> &rsaquo;</a></span><span v-show="this.slotVisible"><slot>TEXT</slot></span></span>'
});


/*
// explicit installation required in module environments
Vue.use(VueFire)
*/
var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

//var Vue = require('vue')
//console.log(Vue.someVar);

/*
Trying to set a global variable that is accessible from components
i.e. needed for "completed" => update header
*/

var Vuex = require('vuex')

//console.log(this);

var Firebase = require('firebase')
var usersRef = Firebase.database().ref('users')
var entriesRef = Firebase.database().ref('totalentries')

function encodeAsFirebaseKey(string) {
  return string.replace(/\%/g, '%25')
    .replace(/\./g, '%2E')
    .replace(/\#/g, '%23')
    .replace(/\$/g, '%24')
    .replace(/\//g, '%2F')
    .replace(/\[/g, '%5B')
    .replace(/\]/g, '%5D');
};


/*
var user = firebase.auth().currentUser;
var name, email, photoUrl, uid;

if (user != null) {
  name = user.displayName;
  email = user.email;
  photoUrl = user.photoURL;
  uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                   // this value to authenticate with your backend server, if
                   // you have one. Use User.getToken() instead.
}
*/

/*

xvN5xt8ZrkhelZCkCtd0MEqzGaJ3

ecafqXpYE8Y2Pn1Qo8hkxirBsbi1

*/

//import Vue from 'vue'
//import store from './store'

/***********************
 * Pledge.vue settings *
 ***********************/
export default {
  name : 'pledge',
//  store,
  data() {
    return {
      sharedState : this.$store.state,
      pledgeVia: 'facebook.com',
      showErrors : false,
      formattedTotalPeople : 0,
      rawTotalPeople : 0,
      rawUpdatedTotal : 0,
      interval : false,
      
      counter : 0,
      wait : 2000,
      total : 0
    }
  },

  filters: {
    firstName (fullName) {
      var spaceLocation = fullName.indexOf(" ");
      
      if(spaceLocation && spaceLocation > 1){
        return fullName.substring(0, spaceLocation)
      }
      
      return fullName;
    }
  },
  
  // firebase binding
  // https://github.com/vuejs/vuefire
  firebase: {
    users: usersRef
  },
  // computed property for form validation state
  computed: {

    

    // Allow local access to shared state property
    newUser () {
      return this.sharedState.newUser
    },

    // Allow local access to shared state property
    isPledgeCompleted () {
      return this.sharedState.pledgeCompleted
    },


    validation: function() {
      return {
        name: !!this.newUser.name.trim(),
        email: emailRE.test(this.newUser.email)
      }
    },
    isValid: function() {
      var validation = this.validation
      return Object.keys(validation).every(function(key) {
        return validation[key]
      })
    }
  },
  // methods
  methods: {

    resizeCounter: function() {
      
      var counterClass = '';
      var numberLength = this.rawTotalPeople.toString().length;
      //console.log('number: '+ this.rawTotalPeople.toString())
      //console.log('numberLength: '+ numberLength)

      if(numberLength > 4){
        counterClass = 'small'//10K
      }

      if(numberLength > 5){
        counterClass = 'smaller';//100K
      }

      if(numberLength > 6){
        counterClass = 'smallest';//1M
      }
      
      return counterClass;
    },

    getSharingUrl: function() {
      var anchor = this.sharedState.newUser.id ? "#"+this.sharedState.newUser.id : "";
      return 'https://www.runningyear.com/'+anchor;
    },

    share : function(provider) {
      /*
        https://sharelinkgenerator.com/
      */
      var url = '';
      var anchor = this.sharedState.newUser.id ? "%23"+this.sharedState.newUser.id : "";
      var website = 'http%3A//www.runningyear.com/'+anchor;

      switch(provider){
        case 'facebook':
          url = "https://www.facebook.com/sharer/sharer.php?u="+website;
        break;

        case 'twitter':
          url = "https://twitter.com/home?status=I%20pledge%20to%20run%20at%20least%2030%20minutes%20a%20month%20in%20"+this.sharedState.year+".%20Will%20you%20join%20me%3F%20%23RunningYear%20"+website;
        break;

        case 'linkedin':
          url = "https://www.linkedin.com/shareArticle?mini=true&url="+website+"&title=Running%20Year-%20Pledge%20to%20run%20at%20least%2030%20minutes%20a%20month&summary=Join%20a%20community%20of%20people%20who%20have%20pledged%20to%20run%20at%20least%2030%20minutes%20a%20month%20in%20"+this.sharedState.year+",%20gain%20access%20to%20hundreds%20of%20resources%20and%20help%20get%20more%20people%20fit!&source=";
        break;

        case 'mail':
        case 'email':
          url = "mailto:?subject=Pledge%20to%20run%20in%20"+this.sharedState.year+"&body=Join+me+in+pledging+to+run+in+"+this.sharedState.year+"+https:%2F%2Fwww.runningyear.com%2F"+anchor;
        break
      }

      return window.open(url,'targetWindow',
                                   'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=650,height=330');

    },

    // Store user data after authentication
    saveUserData: function(user) {
      
      if(user){

        if(user.displayName){
         this.sharedState.newUser.name = user.displayName; 
        }
        
        if(user.email){
          this.sharedState.newUser.email = user.email; 
        }

        if(user.photoURL){
          this.sharedState.newUser.pic = user.photoURL;
        }

        if(user.uid){
          // Save userID for sharing hash
          this.sharedState.newUser.id = user.uid;
          location.href = "#"+user.uid;
          //console.log("USER ID = "+user.uid);
        }

      }

    },

    pledgeComplete: function() {
      // Show the sharing page
      //console.log("Pledge complete!");
      
      // Mark the pledge as Completed
      this.sharedState.pledgeCompleted = true;
    },

    recordPledge: function( user ) {
      // Save the pledge and user details
      //console.log("Saving pledge!");

      var dbuser = {
        email: (user.email ? user.email : (user.providerData[0].email ? user.providerData[0].email : null)),
        name: (user.displayName ? user.displayName : (user.providerData[0].displayName ? user.providerData[0].displayName : null)),
        photo: (user.photoURL ? user.photoURL : (user.providerData[0].photoURL ? user.providerData[0].photoURL : null)),
        network: (user.providerData[0].providerId ? user.providerData[0].providerId : null),
        location: {
          city: this.sharedState.newUser.location.city,
          country: this.sharedState.newUser.location.country,
          country_code: this.sharedState.newUser.location.code
        }
      };

      var uid = user.uid;

      usersRef.child(uid).once('value', function(snapshot) {
        var pledgeExists = (snapshot.val() !== null);
        
        if (pledgeExists) {
          // User has already pledged (saved)
          //console.log("uid ("+uid+") exists");

        } else {
          // User has not pledged (new)
          //console.log("uid ("+uid+") DOESNT exist. Creating it next");

          // Save user details
          usersRef.child(uid).set(dbuser);

          // Increase pledge counter
          entriesRef.transaction(function(currentVal) {
            isFinite(currentVal) ||  (currentVal = 0);
            return currentVal+1;
          });
        }

      });

      this.pledgeComplete();
    },

    /******************************************************************
     * Handle the user pledge here, both new (signup) and old (login) *
     ******************************************************************/
    pledge: function(providerName) {
      var parent = this;
      var provider = null;

      if(providerName == 'facebook.com'){
        provider = new Firebase.auth.FacebookAuthProvider();

        provider.setCustomParameters({
          'display': 'popup'
        });
      }else if(providerName == 'twitter.com'){
        provider = new Firebase.auth.TwitterAuthProvider();
      }else if(providerName == 'google.com'){
        provider = new Firebase.auth.GoogleAuthProvider();
      }

      if(provider){
        // We're pledging with one of the providers

        //console.log("we have a provider "+providerName);

        Firebase.auth().signInWithPopup(provider).then(function(result) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          //var token = result.credential.accessToken;
          // The signed-in user info.
          var user = result.user;

          //console.log("SignedUp with provider "+providerName);
          //console.log(result);
          //console.log(user);

          // Save user data
          parent.saveUserData(user);

          // Record pledge and save user
          parent.recordPledge(user);

        }).catch(function(error) {
          // Handle Errors elsewhere

          var user = Firebase.auth().currentUser;
          
          //console.log("AUTH ERR")
          //console.log(user);

          // Save user data
          if(user){
            parent.saveUserData(user);
          }

          parent.handlePledgeError(error);
        });

      }else{
        // No provider entered, username & password login

        //console.log("Manual pledge");

        if (!this.isValid) {
          this.showErrors = true;
          return;
        }

        var fullName = this.newUser.name//"Manual Guilermo";
        var email = this.newUser.email//"guille.vigil+3@gmail.com";

        var password = "";

        Firebase.auth().createUserWithEmailAndPassword(email, email).then(function(user) {
          
          //console.log("Manual user created, follows");
          //console.log(user);

          if(fullName){
            // Save the pledge's Full Name

            user.updateProfile({
              displayName: fullName
            }).then(function() {
              // Update successful

              // Save user data
              parent.saveUserData(user);

              // Record pledge
              parent.recordPledge(user);
            });

          }else{
            // We don't have a Full name (displayName)
            
            // Save user data
            parent.saveUserData(user);
            
            // Record pledge
            parent.recordPledge(user);
          }

        }).catch(function(error) {
          // Handle Errors elsewhere

          var user = Firebase.auth().currentUser;
          
          // Save user data
          parent.saveUserData(user);
          parent.handlePledgeError(error);
        });

      }
    },

    /******************************************************************
     * Handle errors with the login/singup flow. May be existing user *
     ******************************************************************/
    handlePledgeError: function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      //console.log(error);

      /*
      if(error.message){
        console.log(error.message);
      }

      if(error.credential){
        // The firebase.auth.AuthCredential type that was used.
        console.log(error.credential);
      }

      if(error.email){
        // The email of the user's account used.
        console.log(error.email);
      }
      */
      
      switch(errorCode){
        case 'auth/account-exists-with-different-credential':
        case 'auth/email-already-in-use':
        case 'auth/credential-already-in-use':
          // They are already a user, have pledged

          //console.log("woops");
          this.pledgeComplete();

        break;

        case 'auth/invalid-email':
          // Invalid email
          alert("Invalid email");
        break;

        default:
          // Any other error. Refresh?
          //console.log("refreshing? "+errorCode);
          //console.log(error);
          //location.reload();
        break;
      }
    },


  /*
     * Gets the total amount of people who have pledged from Firebase
     */
    getTotalPeople() {
      var p = this;

      entriesRef.on("value", function(snap){
        
        p.rawUpdatedTotal = snap.val();

        if(!p.rawTotalPeople){
          // Animate increase from 0

          p.interval = window.setInterval(function(){
        
            if(p.rawTotalPeople != p.rawUpdatedTotal){
              var change = (p.rawUpdatedTotal - p.rawTotalPeople) / 10;
              change = change >= 0 ? Math.ceil(change) : Math.floor(change);
              p.rawTotalPeople = p.rawTotalPeople + change;

              // Format the result for the viewer
              p.formattedTotalPeople = p.rawTotalPeople.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              //var formattedTotal = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              //p.formattedTotalPeople = formattedTotal;
            }else{
              //console.log("interval cleared");
              clearInterval(p.interval);
            }
          
          }.bind(p), 65);

        }else{
          // No animation
          var total = snap.val();
          var formattedTotal = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          p.formattedTotalPeople = formattedTotal;
        }

      })
    }

  },

  mounted() {

    var parent = this;

    // Update the total amount of ppl onload
    this.getTotalPeople();

    /* Check if they've pledged already (user) */
    // this.pledgeComplete();

    Firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        //alert("signed in")
        // Save user data
        parent.saveUserData(user);
        parent.pledgeComplete();
      }
    });

    //console.log("FIRE next")
    //console.log(Firebase.auth().currentUser);
    /*
      var user = Firebase.auth().currentUser;
    
    console.log("USER FOLLOWS");
    console.log(user);

    */
    // Save user data
    //parent.saveUserData(user);

    /*
     * Check if we've come from a shared pledge
     */

    if(window.location.hash) {
      // hash found
      var userId = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
      var userData = null;
      //alert (hash);

      //var userId = 'rx73XvH5KAOSNax4xLlSP6UUkl22'
      usersRef.child(userId).once('value').then(function(snapshot) {
        //var username = snapshot.val().username;
        userData = snapshot.val();

        if(userData){
          // We have a valid user
          parent.sharedState.wasReferred = true;
          parent.sharedState.referralUser = userData;

          if(userData.network){
            //alert(userData.network)
            parent.pledgeVia = userData.network;
          }
          /*
          console.log("snapshot follows");
          console.log(snapshot.val());
          */
        }
      });

    }else{
      // No hash found
    }

  }// end of mounted
}



/*
    var p = this;
    Events.$on('setPledgeComplete', function() {
      // Event was heard
      p.pledgeComplete = true;
    });
    */




/*
 * Firebase example follows
 */

/*

// create Vue app
var app = new Vue({
  // element to mount to
  el: '#app',
  // initial data
  data: {
    newUser: {
      name: '',
      email: ''
    }
  },
  // firebase binding
  // https://github.com/vuejs/vuefire
  firebase: {
    users: usersRef
  },
  // computed property for form validation state
  computed: {
    validation: function() {
      return {
        name: !!this.newUser.name.trim(),
        email: emailRE.test(this.newUser.email)
      }
    },
    isValid: function() {
      var validation = this.validation
      return Object.keys(validation).every(function(key) {
        return validation[key]
      })
    }
  },
  // methods
  methods: {
    addUser: function() {
      if (this.isValid) {
        usersRef.push(this.newUser)
        this.newUser.name = ''
        this.newUser.email = ''
      }
    },
    removeUser: function(user) {
      usersRef.child(user['.key']).remove()
    }
  }
})
*/

</script>

<style>
  body {
    font-family: "Avenir", "Helvetica Neue", Helvetica, Arial, sans-serif;
    /* linear-gradient( rgba(182, 240, 209, 0.1), rgba(182, 240, 209, 0.25) ), */
    background: url(../assets/running-year-bg.jpg);
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #app{
    margin:0 auto;
    width:100%;
  }

  #app .main{
    
  }

    #app .content{
      max-width: 1200px;
      margin: 0 auto;
    }

    #app .pledge-content{

    }

    #pledge-wrap{
        padding-top: 2em;
    }


      #pledge-text{
        background: rgba(255,255,255,0.8);
        text-align: center;
        font-family: "Avenir", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 50px;
        line-height: 1.5em;
        padding: 0.25em 0;
        position: relative;
        margin-bottom: 50px;
      }

      @media only screen and (min-width: 64em) {
      /* Medium screen styles */
        #pledge-text{
          margin-bottom: 0;
        }
      }

      #pledge-text p{
        margin: 0;
        text-align: center;
        line-height: 1.3em;
      }

      #runners-info{
        height: 100%;
        width: 100%;
        margin: 10px 0 20px 0;
      }

      #total-runners{
        font-size: 180px;
        font-weight: 500;
        line-height: 1em;/*180px;*/
      }

      #total-runners.small{
        font-size: 150px;
      }

      #total-runners.smaller{
        font-size: 120px;
      }

      #total-runners.smallest{
        font-size: 100px;
      }

      @media only screen and (max-width: 450px) {

        #pledge-text p{
          font-size: 35px;
        }

        #pledge-text #total-runners{
          font-size: 140px;
        }

        #total-runners.small{
          font-size: 110px;
        }

        #total-runners.smaller{
          font-size: 95px;
        }

        #total-runners.smallest{
          font-size: 75px;
        }
      }

      @media only screen and (max-width: 350px) {
        #pledge-text p{
          font-size: 30px;
        }

        #pledge-text #total-runners{
          font-size: 100px;
        }

        #total-runners.small{
          font-size: 80px;
        }

        #total-runners.smaller{
          font-size: 70px;
        }

        #total-runners.smallest{
          font-size: 55px;
        }
        
      }

      @media only screen and (max-width: 250px) {
        #pledge-text p{
          font-size: 25px;
        }

        #pledge-text #total-runners{
          font-size: 70px;
        }

        #total-runners.small{
          font-size: 60px;
        }

        #total-runners.smaller{
          font-size: 50px;
        }

        #total-runners.smallest{
          font-size: 40px;
        }
      }

      .pledge-footer{
        font-size: 1em;
        position: absolute;
        bottom: -50px;
        height: 54px;
        overflow: hidden;
        width: 100%;
        background: #FFF;
        border-top: 4px solid rgba(204, 204, 204, 0.5);
      }

      #footer-social,
      #footer-email{
        list-style: none;
        margin: 0;
      }

      #footer-social li,
      #footer-email li{
        background-color: #FFF;
        width: 33.33333%;
        margin: 0;
        padding: 0;
        float: left;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
        height: 50px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        line-height: 48px;
        position: relative;
        text-align: center;
      }

      #footer-email li{
        width: 100%;
      }

      #footer-social li:hover,
      #footer-email li:hover{
        border-bottom: 4px solid rgba(51,51,51,0.5);
        cursor:pointer;
        color:#FFF;
      }

      #footer-social span,
      #footer-email span{
        font-size: 24px;
        position: relative;
        top: 2px;
      }

      #footer-social .twitter{
        color: #41AAF1;
        border-bottom: 4px solid #41AAF1;
      }

      #footer-social .twitter:hover{
        background-color: #41AAF1;
      }

      #footer-social .facebook{
        color: #31579C;
        border-bottom: 4px solid #31579C;
      }

      #footer-social .facebook:hover{
        background-color: #31579C;
      }

      #footer-social .linkedin{
        color: #0074B8;
        border-bottom: 4px solid #0074B8;
      }

      #footer-social .linkedin:hover{
        background-color: #0074B8;
      }

      #footer-email .email{
        color: #666666;
        border-bottom: 4px solid #666666;
      }

      #footer-email .email:hover{
        background-color: #666666;
      }

      #footer-social li:active,
      #footer-email li:active{
        opacity: 0.75;
      }

      #referralImage{
        position: relative;
        border: 3px solid rgba(255,255,255,.5);
        border-radius: 50px;
        height: 50px;
        padding: 1px;
        box-shadow: 0px 0px 5px #000;
        top: 10px;
        width: 50px;
        z-index: 1;
        background: rgba(251,251,251,.5);
      }

      #pledge-form{
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        background: rgba(255,255,255,0.8);
        position: relative;

        /* When side-by-side with pledge-text */
        /*overflow-y: scroll;*/
        /*max-height: 47em;43*/
        /*background: 
        linear-gradient(
          rgba(31, 31, 31, 1),
          rgba(51, 51, 51, 1)
        );*/
      }

      #pledge-form section{
        color:#c5c5c5;
        margin: 2em 1.5em;
      }

      #pledge-form a,
      #pledge-form a:link,
      #pledge-form a:visited,
      #pledge-form a:hover,
      #pledge-form a:active{
        color:#333;
      }

      a,
      .read-more{
        text-decoration:none;
      }

      a:hover,
      .read-more:hover{
        text-decoration:underline;
      }

      #pledge-form h3{
        font-size: 1em;
        background-image: linear-gradient(to right, #999 50%, #999 50%);
        background-position: center;
        background-size: 1px 1px;
        background-repeat: repeat-x;
        font-weight: 400;
        letter-spacing: 1px;
        color: #666;
        text-transform: uppercase;
      }

      #pledge-form h3 span{
        padding-right: 0.70em;
        background-image: linear-gradient(to right, #fff 50%, #fff 50%);
        background-position: center;
        background-size: 1px 1px;
        background-repeat: repeat-x;
      }

      #pledge-form p{
        line-height: 1.5em;
        color: #666;
        font-weight: 300;
      }

      #pledge-form .bottomMargin{
        margin-bottom: 2em;
      }

      #pledge-form .inputField{
        width: 100%;
        border: 0;
        border-bottom: 2px solid rgba(51,51,51,0.5);
        outline: none;
        margin: 0;
        padding: 0;
        background-color: transparent;
        font-size: 1.4em;
        font-weight: 200;
        color: #333;
        height: 3em;
        margin-bottom: 1em;
      }

      /* Prevent autofill banana-yellow background on fields */
      #pledge-form .inputField:-webkit-autofill {
        -webkit-text-fill-color: #FFF;
        -webkit-box-shadow: inset 0 0 0px 9999px #333;
      }
      #pledge-form .inputField:-moz-autofill {
        -moz-text-fill-color: #FFF;
        -moz-box-shadow: inset 0 0 0px 9999px #333;
      }
      #pledge-form .inputField:-o-autofill {
        -o-text-fill-color: #FFF;
        -o-box-shadow: inset 0 0 0px 9999px #333;
      }
      #pledge-form .inputField:-khtml-autofill {
        -khtml-text-fill-color: #FFF;
        -khtml-box-shadow: inset 0 0 0px 9999px #333;
      }

      #manualForm .name{
        text-transform: capitalize;
      }

      #pledgeButtons .button,
      #shareButtons .button{
        width: 100%;
        height: 70px;
        position: relative;
        color: #fff;
        border-bottom: 2px solid white;
      }

      #pledgeButtons .facebook:hover button{
        background-color:rgba(69, 97, 157, 0.75);
      }

      #pledgeButtons .facebook:active button,
      #pledgeButtons .facebook button{
        background-color:rgb(69, 97, 157);
      }

      #pledgeButtons .twitter:hover button{
        background-color:rgba(0, 173, 236, 0.7);
      }

      #pledgeButtons .twitter:active button,
      #pledgeButtons .twitter button{
        background-color:rgb(0, 173, 236);
      }

      #pledgeButtons .google:hover button{
        background-color:rgba(242, 67, 36, 0.7);
      }

      #pledgeButtons .google:active button,
      #pledgeButtons .google button{
        background-color:rgb(242, 67, 36);
      }

      #pledgeButtons .email:hover button{
        background-color:rgba(27, 171, 119, 0.7);
      }

      #pledgeButtons .email:active button,
      #pledgeButtons .email button{
        background-color:rgb(27, 171, 119);
      }

      #shareButtons .facebook button:hover{
        background-color: rgba(69, 97, 157, 0.5);
      }

      #shareButtons .facebook button,
      #shareButtons .facebook button:active{
        background-color: rgb(69, 97, 157);
      }

      #shareButtons .twitter button:hover{
        background-color:rgba(0, 173, 236, 0.5);
      }

      #shareButtons .twitter button,
      #shareButtons .twitter button:active{
        background-color:rgb(0, 173, 236);
      }

      #shareButtons .linkedin button:hover{
        background-color:rgba(0, 116, 170, 0.5);
      }

      #shareButtons .linkedin button,
      #shareButtons .linkedin button:active{
        background-color:rgb(0, 116, 170);
      }

      #shareButtons label{
        background: transparent;
        cursor: pointer;
      }

      #pledgeButtons{
        position: relative;
      }

      #shareButtons .button{
        width: 75%;
        margin: 0 auto 1em auto;
        border-bottom-color: rgba(255,255,255,0.75);
      }

      #shareButtons .shareLink{
        width: 75%;
        margin: 0 auto 1em auto;
      }

      #shareButtons .shareLink input{

      }

      @media only screen and (max-width: 70em) {
      /* Medium screen styles */
        #shareButtons .button,
        #shareButtons .shareLink{
          width: 90%;
        }
      }

      @media only screen and (max-width: 48em) {
      /* Medium screen styles */
        #shareButtons .button,
        #shareButtons .shareLink{
          width: 100%;
        }
      }

      #pledgeButtons label,
      #shareButtons label{
        width: 5em;
        display: inline-block;
        height: 100%;
        border-right: 1px solid rgba(51,51,51,0.25);
        margin: 0;
        padding: 0;
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
      }

      #shareButtons label{
        width: 3em;
      }

      #pledgeButtons button,
      #shareButtons button{
        width: 100%;
        margin: 0;
        display: inline-block;
        padding: 0;
        border: 0;
        height: 70px;
        float: left;
        outline: none;
        padding-left: 4em;
        text-align: left;
        font-size: 1.5em;
        font-weight: 400;
        letter-spacing: 1px;
        text-shadow: 0 1px 3px rgba(51,51,51, .5);
      }

      #pledgeButtons .icon-facebook,
      #pledgeButtons .icon-twitter,
      #pledgeButtons .icon-google,
      #pledgeButtons .icon-mail{
        font-size: 2em;
        line-height: 2.2em;
      }

      #shareButtons .icon-facebook,
      #shareButtons .icon-twitter,
      #shareButtons .icon-linkedin{
        font-size: 1.4em;
        line-height: 2.2em;
      }

      #pledgeButtons .dropdown-arrow{
        position: relative;
        bottom: 0.35em;
      }

      #pledgeOptions{
        opacity: 0;/* Hidden */
        width: 5em;
        height: 70px;
        position: absolute;
        left: 0;
        top: 0;
        outline: none;
        color: #333;/* Color of options FF */
        /* Safari full-height */
        -webkit-appearance: menulist-button;
      }

      .errors{
        color:rgb(215, 83, 83);
      }

      @media only screen and (max-width: 64em) {
      /* Medium screen styles */
        #manualForm .inputWrap{
          width: 100%;
        }
      }

      @media only screen and (max-width: 48em) {
      /* Small screen styles */
        
      }

      @media only screen and (max-width: 30em) {
      /* Mobile screen styles */
        
      }

      #privacy{
        padding-left: 2.5em;
        position: relative;
      }

      #privacy .icon-lock{
        position: absolute;
        left: 0;
        top: .5em;
        font-size: 1.3em;
        color: #666;
      }

      .noSelect{
        -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
           -khtml-user-select: none; /* Konqueror */
             -moz-user-select: none; /* Firefox */
              -ms-user-select: none; /* Internet Explorer/Edge */
                  user-select: none; /* Non-prefixed version, currently
                                        not supported by any browser */
      }


      /* Pulsate the pledge button */
      .pulsate {
          -webkit-animation: pulsate 1s infinite alternate;
          -moz-animation: pulsate 1s infinite alternate;
          -animation: pulsate 1s infinite alternate;
      }

      @-webkit-keyframes pulsate {
          from { box-shadow: 0 0 8px #0099CC; }
          to { box-shadow: 0 0 20px rgb(160, 125, 80); }
      }
      @-moz-keyframes pulsate {
          from { box-shadow: 0 0 10px #121212; }
          to { box-shadow: 0 0 20px rgb(160, 125, 80); }
      }
      @keyframes pulsate {
          from { box-shadow: 0 0 10px #121212; }
          to { box-shadow: 0 0 20px rgb(160, 125, 80); }
      }
      

</style>



// WEBPACK FOOTER //
// Pledge.vue?5d9ca3d1